import React from "react";
import AboutMissionImage from "../../assets/images/about-us/mission.png";
import AboutVisionImage from "../../assets/images/about-us/vision.png";
import AboutValueImage from "../../assets/images/about-us/values.png";

const Services = () => {
  return (
    <>
      <section className="about-services-wrapper">
        <div className="max-container">
          <div className="padd-90">
            <h2 className="roboto-bold mb40 heading29px text-center">
              Unlock AI-Driven Solutions to Accelerate Your Hospitality Business Growth <br /> and Stay Ahead of the Competition!
            </h2>

            <div className="grid-auto-fit align-items-center">
              <div>
                <div className="common-white-box common-shadow">
                  <img
                    src={AboutVisionImage}
                    height="60"
                    width="60"
                    alt="Our Vision"
                    className="img-fluid"
                  />
                  <h3 className="heading20px roboto-bold mb10 mt20">Our Vision
                  </h3>
                  <p className="heading16px roboto-regular mt20">
                    To become the leading AI-powered platform for the hospitality industry—enabling hotels worldwide to operate smarter, connect deeper, and grow faster by harnessing the full potential of data, automation, and guest-centric innovation.
                  </p>
                </div>
              </div>
              <div>
                <div className="common-white-box common-shadow">
                  <img
                    src={AboutMissionImage}
                    height="60"
                    width="60"
                    alt="Our Mission"
                    className="img-fluid"
                  />
                  <h3 className="heading20px roboto-bold mb10 mt20">Our Mission</h3>
                  <p className="heading16px roboto-regular mt20">
                    To empower hospitality businesses with intelligent, AI-driven tools that simplify operations, enhance guest experiences, and drive sustainable growth. We aim to transform the way hotels and travel brands engage with prospects and guests—through automation, smart insights, and seamless communication.
                  </p>
                </div>
              </div>
            </div>

            <div className="common-white-box common-shadow mt40">
              <img
                src={AboutValueImage}
                height="60"
                width="60"
                alt="Our Core Values"
                className="img-fluid"
              />
              <h3 className="heading20px roboto-bold mb10 mt20">Our Core Values
              </h3>

              <div className="grid-auto-fit mt20">
                <div>
                  <ul className="points-ul">
                    <li className="heading16px roboto-regular">
                      <strong>Integrity:</strong> We operate with honesty, transparency, and accountability—building lasting trust with hospitality businesses around the world.
                    </li>
                    <li className="heading16px roboto-regular">
                      <strong>Excellence:</strong> We are committed to delivering exceptional experiences through high-quality technology, accurate data, and reliable support that our clients can count on.

                    </li>
                    <li className="heading16px roboto-regular">
                      <strong>Innovation with Purpose:</strong> We leverage AI and emerging technologies to solve real challenges in the hospitality industry, constantly evolving to deliver smarter, more impactful solutions.
                    </li>
                  </ul>
                </div>
                <div>
                  <ul className="points-ul">
                    <li className="heading16px roboto-regular">
                      <strong>Guest-Centric Thinking:</strong> Our platform is designed with your guests in mind—empowering you to personalize engagement, automate interactions, and exceed expectations at every touchpoint.
                    </li>
                    <li className="heading16px roboto-regular">
                      <strong>Continuous Growth:</strong> We believe in progress—for our clients, our platform, and our team. We constantly learn, adapt, and improve to stay ahead of industry shifts and hospitality trends.

                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Services;
